import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import SetupUsername from './components/SetupUsername';
import Layout from './components/Layout';
import Analytics from './pages/Analytics';
import Expenses from './pages/Expenses';
import Settings from './pages/Settings';
import SmsArchive from './pages/SmsArchive';
import Landing from './pages/Landing/Landing';
import Register from './pages/Register';
import { isSessionValid, getUser, setSession, clearSession, getToken } from './services/auth';
import api from './api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const valid = isSessionValid();
    const u = getUser();
    setIsAuthenticated(!!valid && !!u);
    setUser(u);
    setLoading(false);
  }, []);

  const login = (userData, token, remember=false) => {
    setSession(token, userData, remember);
    setUser(userData);
    setIsAuthenticated(true);
  };

  const logout = async () => {
    try {
      const token = getToken();
      if (token) await api.post('/api/auth/logout');
    } catch (_) { /* ignore network errors on logout */ }
    clearSession();
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="container">
        <div className="card">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Landing />} />
        <Route path="/register" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Register />} />
        <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLogin={login} />} />
        <Route path="/setup-username" element={isAuthenticated ? <Layout onLogout={logout} user={user}><SetupUsername user={user} onComplete={setUser} /></Layout> : <Navigate to="/login" />} />
        <Route path="/dashboard" element={isAuthenticated ? <Layout onLogout={logout} user={user}><Dashboard user={user} onLogout={logout} /></Layout> : <Navigate to="/login" />} />
        <Route path="/analytics" element={isAuthenticated ? <Layout onLogout={logout} user={user}><Analytics /></Layout> : <Navigate to="/login" />} />
        <Route path="/expenses" element={isAuthenticated ? <Layout onLogout={logout} user={user}><Expenses /></Layout> : <Navigate to="/login" />} />
        <Route path="/settings" element={isAuthenticated ? <Layout onLogout={logout} user={user}><Settings /></Layout> : <Navigate to="/login" />} />
        <Route path="/archive" element={isAuthenticated ? <Layout onLogout={logout} user={user}><SmsArchive /></Layout> : <Navigate to="/login" />} />
      </Routes>
    </div>
  );
}

export default App;
